<div style="display: flex">
    <i-tabler
            *ngFor="let i of circles"
            [name]="i < rating ? 'circle-filled' : 'circle'"
            class="icon-12">
    </i-tabler>
</div>